import { Box } from 'components/ui';

const RoundedBox = ({ children, ...rest }) => (
  <Box width="100%" p={[3, 4]} my={3} background="black" borderRadius="8px" {...rest}>
    {children}
  </Box>
);

export default RoundedBox;
